<template>
  <span>{{ formatted }}</span>
</template>
<script>
export default {
  name: 'PhoneNumber',
  props: [ 'value' ],
  computed: {
    formatted: function () {
      if (this.value.length == 11) {
        return this.value.substr(0, 1) + ' (' + this.value.substr(1, 3) + ') ' + this.value.substr(4, 3) + '-' + this.value.substr(7, 4)
      } else if (this.value.length == 10) {
        return '1 (' + this.value.substr(0, 3) + ') ' + this.value.substr(3,3) + '-' + this.value.substr(6, 4)
      } else {
        return this.value
      }
    }
  }
}
</script>
